<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { format, fromUnixTime, isSameYear } from 'date-fns';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

const { locale } = useI18n();

const isChineseLocale = computed(() =>
  locale.value?.toLowerCase().startsWith('zh')
);

const readableTime = computed(() => {
  if (!createdAt.value) return '';
  if (isChineseLocale.value) {
    const date = fromUnixTime(createdAt.value);
    const formatPattern = isSameYear(date, new Date())
      ? 'MM-dd HH:mm'
      : 'yyyy-MM-dd HH:mm';
    return format(date, formatPattern);
  }
  return messageTimestamp(createdAt.value, 'LLL d, h:mm a');
});
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
